export const CSV_TEMPLATE_URL =
  'https://s3.amazonaws.com/coursera-university-assets/program-assets/csv/csv-template.csv';

export const UPDATE_PROFILES_CSV_TEMPLATE_URL =
  'https://coursera-university-assets.s3.amazonaws.com/program-assets/csv/update-learner-attributes-template.csv';

export const UPDATE_PROFILES_CSV_TEMPLATE_V2_URL =
  'https://s3.amazonaws.com/coursera-university-assets/program-assets/csv/update-profiles-template-v2.csv';

export const IMPORT_CURRICULUM_TEMPLATE_URL =
  'https://coursera-university-assets.s3.amazonaws.com/program-assets/csv/import_curriculum_template.csv';

export const IMPORT_ACCREDITATION_TAGS_TEMPLATE_URL =
  'https://coursera-university-assets.s3.amazonaws.com/program-assets/csv/import_accreditation_tags_template.csv';

export const DATA_TABLE = {
  ROW_HEIGHT: 56,
  HEADER_HEIGHT: 56,
};

export const MEMBER_DELETION_SCOPES = {
  PROGRAM: 'PROGRAM',
  CONTRACT: 'CONTRACT',
  THIRD_PARTY_ORG: 'THIRD_PARTY_ORG',
};
